<template>
  <div class="login-div">
    <!-- 搜索 -->
    <div class="search-div flexC">
      <div class="search-div-item flexC">
        <div class="labelText">  {{ $t("productManage.addModel.productType") }}</div>
        <Input  class="input-div"  :placeholder="$t('inputPlaceholder')"  clearable  v-model="searchObj.productType"></Input>
      </div>

      <div class="search-div-item flexC">
        <div class="labelText">{{ $t("productManage.addModel.baseType") }}</div>
        <Input  class="input-div"  :placeholder="$t('inputPlaceholder')"  clearable  v-model="searchObj.baseType"></Input>
      </div>

      <div class="search-div-item flexC">
        <div class="labelText">{{ $t("productManage.Release_status") }}</div>
        <Select  :placeholder="$t('selectPlaceholder')"  clearable  class="input-div"  v-model="searchObj.published">
          <Option
            v-for="(item, index) in searchObjArr.publishedType"
            :value="item.id"
            :key="index"
            >{{ item["val"] }}</Option
          >
        </Select>
      </div>

      <div class="search-div-item">
        <Button
          type="info"
          @click="searchItem"
          icon="ios-search"
          style="
            margin-top: 5px;
            height: 44px;
            line-height: 44px;
            width: 96px;
            border-radius: 10px;
          "
          >{{ $t("search") }}</Button
        >
      </div>
    </div>

    <!-- 表格 -->
    <div class="tableCon" style="margin-top: 40px">
      <div class="top flexBC"  v-if="roleType!=3">
        <div>
          <Button
            type="success"
            class="addButton"
            @click="addNewP(1)"
            style="margin-right: 8px"
            >{{ $t("productManage.create") }}</Button
          >
          <Button
            type="primary"
            :disabled="buttonList.editDisabled"
            class="addButton"
            @click="addNewP(2)"
            style="margin-right: 8px"
            >{{ $t("productManage.editModel.title") }}</Button
          >
          <Button
            type="warning"
            @click="addData"
            style="margin-right: 8px; border-radius: 6px"
            >{{ $t("productManage.ManageGroup") }}</Button
          >
          <Button
            type="error"
            :disabled="buttonList.editDisabled"
            @click="delData"
            style="margin-right: 8px; border-radius: 6px"
            >{{ $t("delete") }}</Button
          >
          <!-- <Button  :disabled="buttonList.editDisabled" @click="showEvaluate" style="margin-right:8px;">{{$t("productManage.Evaluate")}}</Button> -->
        </div>
      </div>


      <Table
        style="width: 100%; margin-top: 30px"
        :columns="titleName"
        :data="tableList.tableData"
        ref="selection"
        @on-sort-change="sortCustom"
        @on-selection-change="selectChange"
        :loading="loading"
      ></Table>
      <Page
        @on-change="changePage"
        @on-page-size-change="changeSize"
        :total="page.total"
        show-sizer
        :show-total="true"
        :current="page.current"
        :page-size="page.pageSize"
        :page-size-opts="[10, 15, 20]"
        placement="top"
        class="pages"
      />
    </div>

    <!-- 新增、编辑产品 -->
    <ModelBox
      :showModel.sync="addBox.showModel"
      :fn="addBox.callbackFn"
      :type="type"
      :editFormData="addBox.editFormData"
    ></ModelBox>

    <!-- 产品功能管理 -->
    <FuctionBox
      :showModel.sync="funBox.showModel"
      :fn="funBox.callbackFn"
      :editFormData="funBox.editFormData"
    ></FuctionBox>

    <!-- 产品组管理 -->
    <manageModelBox
      :showModel.sync="detailBox.showModel"
      :fn="detailBox.callbackFn"
      :editFormData="detailBox.editFormData"
    ></manageModelBox>

    <!-- 删除 -->
    <DeleteDialog ref="deleteChild" @ievent="ievent"></DeleteDialog>

     <!-- 评价查看 -->
     <ModelEvaluateBox :showModel.sync="evaluateBox.showModel" :fn="evaluateBox.callbackFn"  :editFormData="evaluateBox.editFormData"></ModelEvaluateBox>
  </div>
</template>

<script>
import common from "@/common/common.js";
import moment from "moment";
import ModelBox from "./component/addModel";
import FuctionBox from "./component/functionModel";
import manageModelBox from "./component/manageModel.vue";
import ModelEvaluateBox from "./component/evaluateModel.vue";
import DeleteDialog from "../common/deleteModel.vue"; // 引入删除弹框组件
import Loding from "../common/Loding.vue";
import { mapState } from "vuex";

export default {
  name: "deviceManage",
  components: {
    ModelBox,
    manageModelBox,
    DeleteDialog,
    FuctionBox,
    Loding,
    ModelEvaluateBox
  
  },
  data() {
    return {
      loading: true,
      type: 1, //弹框打开类型 1添加 2编辑
      tableList: {
        //表格组
        hasSelectData: {}, //已选中的行的数据
        tableData: [], //表格数据
        tableDataAll: [],
      },
      buttonList: {
        //按钮组
        editDisabled: true, //编辑按钮是否禁用
        publishedDisabled: false, //编辑按钮是否禁用
      },
      addBox: {
        //规格弹框组-新增编辑
        showModel: false, //弹框开关
        callbackFn: () => {}, //弹框的回调函数
        editFormData: {}, //编辑时传入的现有数据
      },
      funBox: {
        //规格弹框组-功能管理
        showModel: false, //弹框开关
        callbackFn: () => {}, //弹框的回调函数
        editFormData: {}, //编辑时传入的现有数据
      },
      evaluateBox:{//规格弹框组-详情
          showModel:false,//弹框开关
          callbackFn:()=>{}, //弹框的回调函数
          editFormData:{},//编辑时传入的现有数据
      },
      detailBox: {
        //规格弹框组-产品组管理
        showModel: false, //弹框开关
        callbackFn: () => {}, //弹框的回调函数
        editFormData: {}, //编辑时传入的现有数据
      },
      paging: true,//分页是否是真的
      page: {
        //分页排序
        total: 0, //总条数
        pageSize: 10, //每页条数
        current: 1, //当前页
        key: "id",
        order: "desc",
      },
      searchObj: {
        productType: "",
        published: "",
        baseType: "",
      },
    };
  },
  computed: {
    ...mapState(["local", "selectId"]),
    roleType(){
	    	 let res = 3
	    	 if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	    		 res = this.$store.state.uInfo.roleType
	    	 }
	    	 return res
	   },
    searchObjArr() {
      return {
        publishedType: [
          { id: "true", val: this.$t("selectList.standardTypeList.Yes") },
          { id: "false", val: this.$t("selectList.standardTypeList.No") },
        ],
      };
    },
    titleNameAll() {
      return [
        {
          type: "selection",
          width: 60,
          align: "center",
          fixed: "left",
        },
        {
          title: this.$t("productManage.addModel.TypeID"),
          key: "id",
          minWidth: 90,
          sortable: true,
        },
        {
          title: this.$t("productManage.addModel.photo"),
          key: "id",
          minWidth: 150,
          render: (h, params) => {
            let photo = (params.row.photo.split(','))[0]
            return h(
              "div",
              {
                style: {
                  "over-flow": "hidden",
                  height: "63px",
                  position: "relative",
                },
              },
              [
                h("img", {
                  attrs: {
                    src: this.config.sourceUrl + "?fid=" + photo,
                  },
                  style: {
                    height: "100%",
                    "vertical-align": "middle",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                  },
                }),
              ]
            );
          },
        },
        {
          title: this.$t("productManage.addModel.Templet"),
          key: "basicTypeId",
          minWidth: 100,
        },
        {
          title: this.$t("productManage.addModel.baseType"),
          key: "baseType",
          minWidth: 160,
        },
        {
          title: this.$t("productManage.addModel.newFirmware"),
          key: "newestFwareNoPlan",
          minWidth: 160,
          render: (h, params) => {
            // let stext = params.row.normalMode ? params.row.normalMode : "";
            return h("div", params.row.newestFwareNoPlan || "");
          },
        },
        {
          title: this.$t("productManage.addModel.productType"),
          key: "productType",
          minWidth: 160,
        },
        {
          title: this.$t("productManage.addModel.name"),
          key: "name",
          minWidth: 180,
          render: (h, params) => {
            return h(
              "div",
              {
                attrs: {
                  title: params.row.name,
                },
              },
              params.row.name
            );
          },
        },
        {
          title: this.$t("productManage.addModel.normalMode"),
          key: "normalMode",
          minWidth: 130,
          render: (h, params) => {
            let flag = params.row.normalMode ? "1" : "2";
            let obj = {1:this.$t('selectList.standardTypeList.Yes'),2:this.$t('selectList.standardTypeList.No')}
            let stext = obj[flag];
            return h("div", stext || "");
          },
        },
        {
          title: this.$t("productManage.addModel.groupId"),
          key: "groupName",
          minWidth: 160,
        },
        {
          title: this.$t("productManage.addModel.marketDate"),
          key: "marketDate",
          minWidth: 130,
          render: (h, params) => {
            let stext = moment(params.row.marketDate * 1).format("YYYY-MM-DD");
            return h("div", stext || "");
          },
        },
        {
          title: this.$t("productManage.addModel.status"),
          key: "status",
          minWidth: 120,
          render: (h, params) => {
            let flag = params.row.status;
            let obj = { 1: this.$t("selectList.StatusList.Test"), 2: this.$t("selectList.StatusList.Big_sale"), 3: this.$t("selectList.StatusList.Stop_sale") };
            let stext = obj[flag];
            return h("div", stext || "");
          },
        },
        {
          title: this.$t("productManage.addModel.sellUnitPrice"),
          key: "sellUnitPrice",
          minWidth: 150,
        },
        {
          title: this.$t("productManage.addModel.activateUnitPrice"),
          key: "activateUnitPrice",
          minWidth: 150,
        },

        {
          title: this.$t("productManage.addModel.CreateTime"),
          key: "createDate",
          minWidth: 180,
          render: (h, params) => {
            let stext = moment(params.row.createDate * 1).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            return h("div", stext || "");
          },
        },
        {
          title: this.$t("orderManage.titleName.Operation"),
          minWidth: 160,
          key: "id",
          fixed: "right",
          render: (h, params) => {
            let that = this;
            return [
              h(
                "div",
                {
                  style: {
                    display: "flex",
                    justifyContent: "center",
                  },
                },
                [
                  h(
                    "Poptip",
                    {
                      props: {
                        confirm: true,
                        transfer: true,
                        type: "error",
                        size: "large",
                        title: that.$t("productManage.popTitle"),
                        loading:true
                      },

                      on: {
                        "on-ok": () => {
                          this.publishProduct(params.row);
                        },
                        'on-popper-hide':()=>{
                          console.log('on-popper-hide')
                        }
                      },
                    },
                    [
                      h(
                        "Button",
                        {
                          props: {
                            type: "primary",
                            size: "small",
                            disabled: params.row.published,
                          },
                          style: {
                            marginRight: "5px",
                          },
                        },
                        that.$t("productManage.addModel.Publish")
                      ),
                    ]
                  ),

                  h(
                    "Button",
                    {
                      props: {
                        // type: "default",
                        size: "small",
                      },
                      style: {
                        background: "#19be6b",
                        color: "#fff",
                        borderColor: "#19be6b",
                        // borderRadius: "6px",
                      },
                      on: {
                        click: () => {
                          this.editFuction(params.row);
                        },
                      },
                    },
                    that.$t("productManage.addModel.Function_Editor")
                  ),
                ]
              ),
            ];
          },
        },
      ];
    },
    titleName() {
    let titles  = [...this.titleNameAll];

    if (this.roleType ==3) {
      return titles.slice(1, -1).filter(item => 
        item.key !== 'sellUnitPrice' && item.key !== 'activateUnitPrice'
      );
    }
    return titles;
  }
  },
  created() {
    this.getData();
  },
  mounted() {
    //   console.log(document.querySelector('.ivu-table-body').offsetHeight())
  },
  methods: {
    showEvaluate(){
      this.evaluateBox.showModel = true
      this.evaluateBox.editFormData = this.tableList.hasSelectData
      this.evaluateBox.callbackFn = () => {//回调处理
          //重新载入
          this.clearbtnStatus()
          this.evaluateBox.showModel = false;
      }
    },
    delData(item) {// 删除
      
      this.$refs.deleteChild.showit();
    },
    ievent() {// 删除
      
      // console.log("删除");
      let url = this.config.urlArray.productsDel;
      this.axios
        .post(url, { id: this.tableList.hasSelectData.id })
        .then((result) => {
          common.ajaxMsg(result.data, true, () => {
            this.$refs.deleteChild.recancel();
            this.clearbtnStatus();
            this.getData();
          });
        })
        .catch((err) => {
          // common.msg('error',this.$t('failed'))
        });
    },
    editFuction(item) { //功能编辑
     
      this.funBox.showModel = true;
      this.funBox.editFormData = item;
      this.funBox.callbackFn = () => {
        //回调处理
        //重新载入
        this.clearbtnStatus();
        this.funBox.showModel = false;
        // this.getData();
      };
    },
    publishProduct(item) {//发布产品
      // console.log(6666)
      if(this.buttonList.publishedDisabled==false){
          this.buttonList.publishedDisabled = true;
          //    console.log(9999)
          //    setTimeout(() => {
          //    this.buttonList.publishedDisabled = false;
          // }, 500);
        this.axios
        .post(this.config.urlArray.productsPublish, { id: item.id })
        .then((result) => {
          common.ajaxMsg(result.data, true);
          this.getData();
          setTimeout(() => {
             this.buttonList.publishedDisabled = false;
          }, 1500);
        },()=>{
          this.buttonList.publishedDisabled = false;
        });
      }
      // this.axios
      //   .post(this.config.urlArray.productsPublish, { id: item.id })
      //   .then((result) => {
      //     common.ajaxMsg(result.data, true);
      //     this.getData();
      //   });
    },
    addNewP(type, item = {}) {//创建产品数据
      
      this.addBox.showModel = true;
      this.type = type;
      if (type == 2) {
        // this.addBox.editFormData = item
        this.addBox.editFormData = this.tableList.hasSelectData;
      }
      this.addBox.callbackFn = () => {
        //回调处理
        //重新载入
        this.addBox.showModel = false;
        this.clearbtnStatus();
        this.getData();
      };
    },
    addData() {
      this.detailBox.showModel = true;
      this.detailBox.callbackFn = () => {
        //回调处理
        //重新载入
        this.clearbtnStatus();
        this.detailBox.showModel = false;
        // this.getData();
      };
    },

    searchItem() {//搜索
      this.page.current = 1
      this.page.pageSize = 10
      this.getData();
    },
    getData() {//获取数据
      
      // let querySearch = this.searchObj.published?'/'+this.searchObj.published:''
      let params = {
        page: this.page.current,
        limit: this.page.pageSize,
        key: this.page.key,
        order: this.page.order,
        ...this.searchObj,
      };

      // Object.assign(getData.params,this.searchObj)
      this.loading = true;

      this.axios
        .post(this.config.urlArray.productsManageList, {
          ...params,
          dealerId: this.selectId,
        })
        .then((result) => {
          common.ajaxMsg(result.data,false);
          let resData = result.data.data;
          
          //处理数组
          if (resData) {
            if (!resData.meta) {
              //分页不生效
              this.tableList.tableDataAll = resData;
              resData = resData.map((item) => {
                item.marketDate1 = moment(item.marketDate / 1).format("YYYY-MM-DD");
                return item;
              });
              this.paging = false;
              this.page.total = result.data.data.length;
              this.getDataPage();
            } else {
              this.tableList.tableData = resData.productList.map((item) => {
                item.marketDate1 = moment(item.marketDate / 1).format("YYYY-MM-DD");
                return item;
              });
              this.page.total = resData.meta.count;
            }

            this.loading = false;
          } else {
            this.tableList.tableData = [];
            this.page.total = 0;
            this.loading = false;
            return false;
          }

          this.loading = false;
        })
        .catch((err) => {
          // common.msg('error','获取失败',()=>{})
        });
    },
    filterData(list) {
      let published = this.searchObj.published
        ? this.searchObj.published === "true"
          ? true
          : false
        : "";
      let searchObj = { ...this.searchObj, published };
      let searchArr = Object.keys(this.searchObj);
      searchArr.map((item) => {
        if (searchObj[item] !== "") {
          list = list.filter((iitem) => {
            // return iitem[item] == searchObj[item];
            return iitem[item].includes(searchObj[item]);
          });
        }
      });
      return list;
    },
    getDataPage() {
      let start = (this.page.current - 1) * this.page.pageSize;
      let end = this.page.current * this.page.pageSize;
      let key = this.page.key;
      let order = this.page.order;

      this.tableList.tableDataAll = this.filterData([
        ...this.tableList.tableDataAll,
      ]);

      this.page.total = this.tableList.tableDataAll.length;

      this.tableList.tableDataAll = this.tableList.tableDataAll.sort((a, b) => {
        if (order == "asc") {
          return a[key] - b[key];
        } else if (order == "desc") {
          return b[key] - a[key];
        }
      });
      this.tableList.tableData = this.tableList.tableDataAll.slice(start, end);
    },

    selectChange(res) {//控制编辑和删除按钮的可用状态
      
      // console.log(res,'44')
      if (res.length == 1) {
        this.buttonList.editDisabled = false;
        this.tableList.hasSelectData = res[0];
      } else if (res.length == 0) {
        this.buttonList.editDisabled = true;
        this.tableList.hasSelectData = {};
      } else {
        this.buttonList.editDisabled = true;
        this.tableList.hasSelectData = res[0];
      }
    },
    sortCustom(data) {//自定义排序
      
      this.page.key = data.key;
      this.page.order = data.order;
      if (this.paging) {
        this.getData();
      } else {
        this.page.current = 1
        this.getDataPage();
      }
    },

    changePage(nowpage) {//切换分页
      
      this.page.current = nowpage;
      if (this.paging) {
        this.getData();
      } else {
        this.getDataPage();
      }
    },
    changeSize(nowSize) {//切换每页显示条数
      
      this.page.pageSize = nowSize;
      this.page.current = 1;
      if (this.paging) {
        this.getData();
      } else {
        this.getDataPage();
      }
    },
    clearbtnStatus() {//删除后清空编辑数据 与按钮状态
      
      this.buttonList.editDisabled = true;
      this.buttonList.publishedDisabled = false;
      this.tableList.hasSelectData = {};
    },
  },
};
</script>
 <style scoped lang="less">
.goodsCon {
  flex-wrap: wrap;
  .goodsItem {
    width: 22.5%;
    margin-left: 2%;
    background-color: #fff;
    border: 2px solid #e5e5e5;
    border-radius: 10px;
    padding: 20px 30px;
    margin-bottom: 40px;
    min-width: 193px;
    overflow-x: hidden;
    cursor: pointer;
    .imgCon {
      width: 120px;
      height: 120px;
      margin: 0 auto;
      img {
        width: auto;
        height: 100%;
        max-width: calc(100% + 90px);
      }
    }
    .goodName {
      color: #3a464e;
      margin-top: 7px;
      text-align: center;
    }
    .bottomInfo {
      margin-top: 40px;
      color: #3a464e;
      text-align: center;
      line-height: normal;
      .desc {
        font-size: 12px;
        color: #a4b4bf;
        margin-top: 15px;
      }
      .dataNum {
        height: 26px;
        line-height: 26px;
      }
      .numCon {
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #e76d6a;
      }
    }
  }
}
.labelText {
  line-height: 54px;
  height: 54px;
  flex-shrink: 0;
  margin-right: 10px;
}
.echartsCon {
  background: #fff;
  margin: 40px 40px;
  border-radius: 14px;
  padding: 20px 40px;
  #main {
    // width: 100%;
    flex-grow: 1;
    height: 400px;
    margin: auto;
    margin-top: 30px;
  }
  .titleCon {
    width: 350px;
    flex-shrink: 0;
    .titleConItem {
      border-bottom: 2px solid #eef1f4;
      padding: 20px 18px 20px 35px;
      color: #3a464e;
      position: relative;
      &:nth-last-of-type(1) {
        border-bottom: none;
      }
      &::before {
        content: "";
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 6px;
        height: 26px;
        background: #4e77ef;
      }
      &:nth-of-type(2) {
        &::before {
          background: #ffb139;
        }
      }
      &:nth-of-type(3) {
        &::before {
          background: #3bc1db;
        }
      }

      .num {
        font-size: 20px;
        font-weight: bold;
      }
      .desc {
        line-height: normal;
      }
    }
  }
}

.search-div {
  flex-wrap: wrap;
  background-color: #fff;
  padding: 34px 40px;
  background: #ffffff;
  margin: 40px 40px 0px;
  border-radius: 14px;
  .search-div-item {
    margin-right: 20px;
    span {
      margin-right: 30px;
    }
  }
  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    height: 44px;
    line-height: 44px;
  }
  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    height: 44px;
    line-height: 44px;
  }
  /deep/ .ivu-select-single .ivu-select-selection {
    height: 44px;
    width: 200px;
  }
  /deep/ .ivu-input {
    height: 44px;
    line-height: 44px;
  }
  /deep/ .ivu-input-icon {
    height: 44px;
    line-height: 44px;
  }
}

.tableCon {
  background-color: #fff;
  padding: 34px 40px 30px 34px;
  background: #ffffff;
  margin: 20px 40px;
  border-radius: 14px;
  //  min-height: 78vh;
  .top {
    margin: 0 0 30px;
    .optionsIcon {
      margin-right: 15px;
    }
    .moveBotton {
      background: #3bc1db;
      color: #fff;
      border-color: #3bc1db;
      border-radius: 6px;
    }
  }
}
.login-div {
  min-height: calc(100vh - 128px);
}
/deep/ .ivu-table td,
.ivu-table th {
  height: 70px;
}
//  /deep/ .ivu-table-fixed-body{
//      height: 100% !important;
//      max-height: 710px;
//  }
</style>
